/**
 * Labstep
 *
 * @module components/Layout/Menu/TopBar/Mobile
 * @desc Mobile top bar
 */

import { GroupItem } from 'labstep-web/components/Group/Item';
import { LayoutMenuTopbarBreadcrumbTitle as Title } from 'labstep-web/components/Layout/Menu/TopBar/Breadcrumb/Title';
import { OrganizationItem } from 'labstep-web/components/Organization/Item';
import { withActiveGroup } from 'labstep-web/containers/ActiveGroup';
import { withAuthenticatedUserEntity } from 'labstep-web/containers/AuthenticatedUser';
import { withSidebar } from 'labstep-web/containers/Ui/Sidebar';
import { Icon } from 'labstep-web/core/Icon';
import type React from 'react';
import styles from './styles.module.scss';
import type { LayoutMenuBreadcrumbMobileProps } from './types';

export const BreadcrumbMobile: React.FC<
  LayoutMenuBreadcrumbMobileProps
> = ({
  breadcrumb,
  activeGroup,
  authenticatedUserEntity,
  setSidebar,
}) => {
  const { group, title } = breadcrumb;

  let component: React.ReactNode;

  if (title) {
    component = <Title title={title} />;
  } else if (group && activeGroup) {
    component = <GroupItem group={activeGroup} />;
  } else {
    component = authenticatedUserEntity.userOrganization && (
      <OrganizationItem
        organization={
          authenticatedUserEntity.userOrganization.organization
        }
      />
    );
  }

  return (
    <div
      className={styles.sidebar}
      onClick={() => {
        setSidebar(true, 'left');
      }}
    >
      <Icon className={styles.sidebarIcon} name="bars" size="large" />
      {component}
    </div>
  );
};

export const BreadcrumbMobileWrapper = withAuthenticatedUserEntity(
  withActiveGroup(withSidebar(BreadcrumbMobile)),
);
